import { HomePageSetting, HttpResponse, IApiService, IProgramApi } from 'types';

export class ProgramApi implements IProgramApi {
    constructor(private readonly apiService: IApiService) {}

    public getSettings(id?: string): Promise<HttpResponse<HomePageSetting>> {
        return this.apiService.request<HomePageSetting>({
            method: 'GET',
            url: `/Program/GetSettings`,
            params: {
                id,
            },
        });
    }
}
